<template>
  <div class="diamond-certificate-checker">
    <DefTitle :result="1" :center="true">
      <h1>
        {{ messages?.checkingRepairStatus }}
      </h1>
    </DefTitle>
    <form class="checking-certificate-form" @submit.prevent="handlerSubmit">
      <DefInput
        :placeholder="messages?.enterBarcode"
        :is-show-error="!!reactiveData?.error"
        :is-error="!!reactiveData?.error"
        name="barcode"
        :error-text="reactiveData?.error"
        type="number"
        required
      />
      <DefButtonPrimary type="submit" :big="true">
        {{ messages?.check }}
      </DefButtonPrimary>
    </form>
  </div>
</template>

<script lang="ts" setup>
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed, reactive } from 'vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import axios from 'axios';
import useLoader from '@use/useLoader/useLoader';
import type { IDiamondCertificateResponse } from '@components/Diamonds/DiamondCertificate/IDiamondCertificate';

const emit = defineEmits(['setDiamondResponse']);

const resultsStore = useResultsStore();
const loader = useLoader();

const messages = computed(() => resultsStore.diamondCertificate.messages);
const getJewelInfoByBarcode = computed(
  () => resultsStore.diamondCertificate?.routes?.getJewelInfoByBarcode
);

interface IErrorResponse {
  error: string;
}

interface IReactiveData {
  error?: string;
}

const reactiveData = reactive<IReactiveData>({});

const handlerSubmit = async (e: SubmitEvent) => {
  try {
    if (!getJewelInfoByBarcode.value) return;

    const formData = new FormData(e.target as HTMLFormElement);

    formData.set('action', getJewelInfoByBarcode.value.action);

    loader.start();

    type TJewelInfoResponse = IDiamondCertificateResponse | IErrorResponse;

    const { data } = await axios.post<TJewelInfoResponse>(
      getJewelInfoByBarcode.value.path,
      formData
    );

    if ('error' in data) {
      reactiveData.error = data.error;
    } else {
      emit('setDiamondResponse', data);
    }
  } catch (err) {
    console.error(err);
  } finally {
    loader.stop();
  }
};
</script>

<style lang="scss" scoped>
.diamond-certificate-checker {
  max-width: 638px;
  margin: 8px auto 64px;
  @include point-lg {
    margin: 24px auto 80px;
  }
}
.checking-certificate-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  @include point-md {
    grid-template-columns: 1fr 276px;
    grid-column-gap: 16px;
  }
}
</style>
